
export default {
  name: 'DragIcon',
};
